<template>
    <v-layout column class="one-character-search" v-if="searchText && searchText.length > 0" >
        <v-flex xs12 sm8 md5 lg4 class="one-character-search__search-text">
            {{`${capitalizeFirstLetter(searchText)} ...?`}}
        </v-flex>
        <v-flex xs12 sm8 md5 lg4 class="one-character-search__message">
            {{globalSearchConstants.ONE_CHARACTER_SEARCH_ERROR}}
        </v-flex>
    </v-layout>
</template>

<script>
    import { globalSearchConstants } from "./ypoSearch.constants";

    export default {
        name: 'OneCharacterInterstitialPage',
        props: {
            searchText: {
                required: true,
                type: String,
            },
        },
        data() {
            return {
                globalSearchConstants,
            };
        },
        methods: {
            capitalizeFirstLetter(word) {
                const firstLetter = word.charAt(0).toUpperCase();
                const restOfTheLetters = word.slice(1, word.length);
                return `${firstLetter}${restOfTheLetters}`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .one-character-search {
        margin: auto;
        width: 378px;
        @include breakpoint(xs) {
            width: 100%;
        }
        color: $black;
        font-family: Raleway,serif;
        font-size: 17px;
        font-style: italic;
        font-weight: 500;

        &__search-text {
            text-align: left;
            margin-top: 83px;
            margin-bottom: 10px;
            color: $ypo-cta;
            font-size: 20px;
            font-weight: 600;
            line-height: 22px;
            font-family: Raleway,serif;
        }

        &__message {
            margin-top: 7px;
            text-align: left;
            color: $black;
            font-family: Raleway,serif;
            font-size: 17px;
            font-style: italic;
            font-weight: 500;
            line-height: 22px;
        }

    }

</style>
